import 'components/ckeditor.tag'
riot.tag2('geotargeting-addpage-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Добавить/изменить базовую страницу</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}" if="{!item.id}">\n          <label class="control-label"> URL страницы</label>\n          <input class="form-control" name="name" type="text" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    modal.item = opts.item || {};
    modal.error = false;
    modal.item = {};
    modal.mixin('validation');
    modal.mixin('change');
    //modal.update()

    modal.rules = {
        name: 'empty'
    };

    modal.afterChange = function (e) {
        var name = e.target.name;
        delete modal.error[name];
        modal.error = (0, _extends3.default)({}, modal.error, modal.validation.validate(modal.item, modal.rules, name));
    };
});
});


// WEBPACK FOOTER //
// ./pages/settings/geotargeting/geotargeting-addpage-modal.tag